@if (isVisible() && data(); as data) {
  @let id = data.id;
  @let standOutImage = data.standOutImage;
  @let primaryTitle = data.primaryTitle;
  @let secondaryTitle = data.secondaryTitle;
  @let secondarySubTitle = data.secondarySubTitle;
  @let secondaryBgColor = data.secondaryBackgroundColor;
  @let googlePlayUrl = data.googlePlayUrl;
  @let appStoreUrl = data.appStoreUrl;
  <div class="relative tablet:flex" [attr.aria-labelledby]="'mobile-banner-title-' + id">
    @if (standOutImage) {
      <img
        [src]="standOutImage.url | scCmsImage"
        class="absolute top-[15px] h-[190px] z-10 right-[-15px] desktop:right-[-35px] tablet:h-auto tablet:right-[-30px]"
        alt=""
      />
    }
    <div
      class="pl-10 flex items-center h-[220px] relative tablet:min-w-[326px] desktop:min-w-[374px] tablet:h-auto desktop:pl-0 tablet:justify-center desktop:text-center tablet:pl-0 tablet:items-center"
    >
      <div
        class="absolute top-0 left-0 right-0 bottom-0 bg-cover bg-center -scale-x-100"
        [style.backgroundImage]="getBackgroundStyle()"
      ></div>
      <h3
        class="banner-title text-left w-[160px] tablet:w-[190px] tablet:text-center banner-title"
        [attr.data-title]="primaryTitle"
        [id]="'mobile-banner-' + id"
      >
        {{ primaryTitle }}
      </h3>
    </div>

    <div
      class="p-8 tablet:min-w-[410px] tablet:pl-12 desktop:px-12 desktop:py-[76px] desktop:w-full"
      [style.backgroundColor]="secondaryBgColor"
    >
      <h2
        class="text-mobileH2 tablet:text-tabletH2 font-headline mb-3 desktop:text-desktopH2 desktop:w-[280px] tablet:w-[220px]"
      >
        {{ secondaryTitle }}
      </h2>
      <p
        class="text-mobileMd tablet:text-tabletMd mb-9 desktop:text-desktopMd desktop:w-[280px] tablet:w-[220px]"
        [innerHTML]="secondarySubTitle"
      ></p>
      <div class="flex tablet:flex-col desktop:flex-row">
        @if (googlePlayUrl) {
          <a
            [href]="googlePlayUrl"
            target="_blank"
            class="mr-3 tablet:mb-3 desktop:mb-0"
            aria-label="Download Mobile App on Google Play"
            rel="noopener noreferrer"
          >
            <img src="../../../../assets/images/google-play-icon.png" alt="" />
          </a>
        }
        @if (appStoreUrl) {
          <a
            [href]="appStoreUrl"
            target="_blank"
            aria-label="Download Mobile App on App Store"
            rel="noopener noreferrer"
          >
            <img src="../../../../assets/images/app-store-icon.png" alt="" />
          </a>
        }
      </div>
    </div>
  </div>
}
